export const ACCESS_TOKEN = 'token';

const auth = {
    token: null
};

auth.token = localStorage.getItem(ACCESS_TOKEN);
export default auth;